import { cn } from "@/lib/utils";

export function Panel({ className, children, title, right, testid, icon: Icon }) {
  return (
    <section data-testid={testid} className={cn("panel p-4 md:p-5 fade-up", className)}>
      {(title || right) && (
        <header className="flex items-center justify-between mb-4 gap-3">
          <h3 className="font-display text-sm font-semibold tracking-wide text-zinc-300 uppercase flex items-center gap-2">
            {Icon && <Icon className="w-4 h-4 text-[#F7931A]" />}
            {title}
          </h3>
          {right}
        </header>
      )}
      {children}
    </section>
  );
}

export function Metric({ label, value, sub, tone, testid, big }) {
  const color = tone === "up" ? "text-emerald-400" : tone === "down" ? "text-red-400" : tone === "gold" ? "text-[#F7931A]" : tone === "blue" ? "text-blue-400" : "text-zinc-50";
  return (
    <div data-testid={testid} className="panel p-4 fade-up">
      <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">{label}</div>
      <div className={cn("font-mono font-bold tabular-nums mt-2", big ? "text-3xl" : "text-xl sm:text-2xl", color)}>{value}</div>
      {sub && <div className="text-xs text-zinc-500 mt-1.5">{sub}</div>}
    </div>
  );
}

const STANCE = {
  bullish: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
  bearish: "text-red-400 bg-red-500/10 border-red-500/30",
  neutral: "text-zinc-400 bg-zinc-500/10 border-zinc-600/40",
  veto: "text-red-300 bg-red-600/15 border-red-600/50",
  approve: "text-emerald-300 bg-emerald-600/10 border-emerald-600/40",
  BUY: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
  SHORT: "text-red-400 bg-red-500/10 border-red-500/30",
  NO_TRADE: "text-amber-400 bg-amber-500/10 border-amber-500/30",
  ok: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
  error: "text-red-400 bg-red-500/10 border-red-500/30",
  data_unavailable: "text-amber-400 bg-amber-500/10 border-amber-500/30",
};

export function Badge({ v, children, testid, className }) {
  return (
    <span data-testid={testid} className={cn("inline-flex items-center gap-1 px-2 py-0.5 rounded border font-mono text-[10px] uppercase tracking-wider font-semibold", STANCE[v] || STANCE.neutral, className)}>
      {children || String(v ?? "—").replace("_", " ")}
    </span>
  );
}

export function Dot({ ok, testid }) {
  const c = ok === true ? "bg-emerald-400" : ok === false ? "bg-red-500" : "bg-zinc-500";
  return <span data-testid={testid} className={cn("inline-block w-2 h-2 rounded-full", c, ok && "live-dot")} />;
}

export function Empty({ children, testid }) {
  return (
    <div data-testid={testid} className="border border-dashed border-zinc-800 rounded-md p-6 text-center text-sm text-zinc-500">
      {children}
    </div>
  );
}

export function PageTitle({ title, sub, right }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-50">{title}</h1>
        {sub && <p className="text-sm text-zinc-500 mt-1 max-w-3xl">{sub}</p>}
      </div>
      {right}
    </div>
  );
}
